import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import TradeUp from "../ui/TradeUp"
import TradeUpHistory from "../ui/TradeupHistory"
import Inventory from "../ui/Inventory"
import MobileHome from '../ui/Mobile'
import itemPage from '../ui/itemPage/index.vue'
import AdminTradeUp from "../ui/AdminTradeUp/index.vue"
import WebSocket from "../ui/WebSocket/WebSocket.vue";
import DisCountHistory from "../ui/DisCountHistory/DisCountHistory.vue";
import Tools from '../ui/Tools/Tools.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        needLogin: false
      }
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        needLogin: false
      }
    },
    {
      path: '/webSocket',
      name: 'WebSocket',
      component: WebSocket,
      meta: {
        needLogin: false
      }
    },
    {
      path: '/TradeUp',
      name: 'TradeUp',
      component: TradeUp,
      meta: {
        needLogin: false
      }
    },
    {
      path: '/AdminTradeUp',
      name: 'AdminTradeUp',
      component: AdminTradeUp,
      meta: {
        needLogin: false
      }
    },
    {
      path: '/tradeUpHistory',
      name: 'TradeUpHistory',
      component: TradeUpHistory,
      meta: {
        needLogin: true
      }
    },
    {
      path: '/inventory',
      name: 'Inventory',
      component: Inventory,
      meta: {
        needLogin: true
      }
    },
    {
      path: '/itemPage',
      name: 'itemPage',
      component: itemPage,
      meta: {
        needLogin: false
      }
    },
    {
      path: '/DisCountHistory',
      name: 'DisCountHistory',
      component: DisCountHistory,
      meta: {
        needLogin: false
      }
    },
    {
      path: '/MobileHome',
      name: 'MobileHome',
      component: MobileHome,
      meta: {
        needLogin: false
      }
    },
    {
      path: '/Tools',
      name: 'Tools',
      component: Tools,
      meta: {
        needLogin: false
      }
    },
    // {
    //   path: '/rechargeOrder',
    //   name: 'Recharge',
    //   component: Recharge,
    //   meta: {
    //     needLogin: false
    //   }
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js